import { createGlobalStyle } from 'styled-components'
import DXUnigothic from './DXUnigothicStd-40.woff'
import SDGothic from './AppleSDGothicNeoL.woff'
import NotoSans from './NotoSansKR-Regular.woff'

export default createGlobalStyle`
    @font-face {
        font-family: "DX유니고딕";
        src: local("DX유니고딕"),
        url(${DXUnigothic}) format('woff');
        font-weight: 300;
        font-style: normal;
    }
    
    @font-face{
        font-family: "Sandoll GothicNeo1";
        src: url("./AppleSDGothicNeoL.woff") format('woff');
        font-weight: 300;
        font-style: normal;
    }
    @font-face{
       font-family: "Noto Sans";
        src: local("Noto Sans"),
        url(${NotoSans}) format('woff');
        font-weight: 300;
        font-style: normal;
    }
    body {
    font-family:'Sandoll GothicNeo1','Noto Sans','DX유니고딕';
  }
`;
